import React from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value }) {
  const navigateTo = useNavigate();
  const mem = value.membership || {};
  const friendlyToggle = mem.statusText === 'Active' ? 'Active' : 'Inactive';

  // ✅ Helper function to format phone in +1 (123)-456-7890 pattern
  const formatPhone = (phone) => {
    if (!phone) return '—';
    // remove all non-digits
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10)
      return `+1 (${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`;
    if (digits.length === 11 && digits.startsWith('1'))
      return `+1 (${digits.slice(1, 4)})-${digits.slice(4, 7)}-${digits.slice(7)}`;
    // fallback if it’s not valid US format
    return phone;
  };

  return (
    <>
      <div className={Classes.customerRow} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}><h5>{value.name}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem2}`}><h5>{value.address}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem3}`}><h5>{formatPhone(value.phone)}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}><h5>{value.lastDelivery}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}><h5>{value.nextDelivery}</h5></div>

        {/* Membership cell: Plan + Status + Period */}
        <div className={`${Classes.rowElem} ${Classes.elem6}`}>
          <div className={Classes.memWrap}>
            <div className={Classes.memTitle}>
              <h5>{mem.planLabel === 'None' ? '' : mem.planLabel}</h5>
              {mem.statusText ? (
                <span
                  className={`${Classes.memBadge} ${mem.planLabel === 'None'
                    ? Classes.nonActiveBadge
                    : Classes.activeBadge
                    }`}
                >
                  {mem.statusText}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          <MoreDropDown userId={value._id} user={value.__raw?.user} />
        </div>
      </div>

      {/* Mobile */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Name</h4><h5>{value.name}</h5></div>
          <div className={Classes.mobElem}><h4>Address</h4><h5>{value.address}</h5></div>
          <div className={Classes.mobElem}><h4>Phone</h4><h5>{formatPhone(value.phone)}</h5></div>
        </div>
        <div>
          <div className={Classes.mobElem}><h4>Last Delivery</h4><h5>{value.lastDelivery}</h5></div>
          <div className={Classes.mobElem}><h4>Next Delivery</h4><h5>{value.nextDelivery}</h5></div>
          <div className={Classes.mobElem}>
            <h4>Membership</h4>
            <div className={Classes.memWrap}>
              <div className={Classes.memTitle}>
                <h5>{mem.planLabel === 'None' ? '' : mem.planLabel}</h5>
                {mem.statusText ? (
                  <span
                    className={`${Classes.memBadge} ${mem.planLabel === 'None'
                      ? Classes.nonActiveBadge
                      : Classes.activeBadge
                      }`}
                  >
                    {mem.statusText}
                  </span>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <MoreDropDown userId={value._id} user={value.__raw?.user} />
      </div>
    </>
  );
}
